import './BasicField.scss'
import { useFormContext } from 'react-hook-form'
import ButtonWithInput from '../../../components/Button/ButtonWithInput'

const BasicField = ({
	name,
	label,
	optional,
	placeholder,
	validation,
	children,
	useChildrenWrapper = true,
	showCheckButton,
	onCheck,
}) => {
	const {
		register,
		setValue,
		formState: { errors },
	} = useFormContext()
	const registration = register(name, validation)
	return (
		<div className="info-box">
			<span>
				{label}
				{optional && <span className="choice"> (선택) </span>}
			</span>
			<div>
				{children ? (
					useChildrenWrapper ? (
						<div className={`fillin-box ${errors?.[name] ? 'error' : ''}`}>
							{children}
						</div>
					) : (
						children
					)
				) : (
					<div className={`fillin-box ${errors?.[name] ? 'error' : ''}`}>
						<input
							className="fillin-input"
							type={name === 'password' ? 'password' : 'text'}
							placeholder={placeholder}
							{...register(name, validation)}
							onChange={(e) => {
								if (name === 'lastname' || name === 'firstname') {
									const val = e.target.value
									// 첫 글자는 대문자, 나머지는 소문자로 변환
									const newVal = val
										.split('')
										.map((char, index) =>
											index === 0 ? char.toUpperCase() : char.toLowerCase(),
										)
										.join('')
									setValue(name, newVal, {
										shouldValidate: false,
										shouldTouch: false,
									})
									e.target.value = newVal
								}
								registration.onChange(e)
							}}
							onBlur={(e) => {
								const val = e.target.value
								if ((name === 'lastname' || name === 'firstname') && val) {
									// 첫 글자는 대문자, 나머지는 소문자로 변환
									const newVal = val
										.split('')
										.map((char, index) =>
											index === 0 ? char.toUpperCase() : char.toLowerCase(),
										)
										.join('')
									setValue(name, newVal, {
										shouldValidate: true,
										shouldTouch: true,
									})
								}
								registration.onBlur(e)
							}}
						/>
					</div>
				)}
			</div>
			<div>
				{errors?.[name] && (
					<div>
						<small className="validation-msg" style={{ color: 'red' }}>
							{errors[name].message}
						</small>
					</div>
				)}
			</div>
		</div>
	)
}

export default BasicField
